import { Component, OnInit } from '@angular/core';
import { GenericRelatorioComponent } from '../generic-relatorio.component';
import { Breadcrumb, GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from 'src/app/shared/components';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AfericaoService, Aferidores } from 'src/app/dio';
import { AferidorService } from 'src/app/dio/aferidor.service';
import { Beneficiaria, BeneficiariaService } from 'src/app/beneficiaria';

@Component({
    selector: 'app-relatorio-afericoes-aferidor',
    templateUrl: './relatorio-afericoes-aferidor.component.html',
    styleUrls: ['./relatorio-afericoes-aferidor.component.css'],
    standalone: false
})
export class RelatorioAfericoesAferidorComponent extends GenericRelatorioComponent implements OnInit {

  breadcrumb: Breadcrumb[] = [
    { label: 'Início' },
    { label: 'Relatórios', route: '/relatorio' },
    { label: 'Relatório DIO\'s aferidas' },
  ]
  
  aferidoresAtivos: any[];
  aferidoresInativos: any[];
  pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
  columns: GenerateTableColumn[] = [
    { header: 'Aferidor', attr: 'aferidor_nome', headerTooltip: 'Nome completo do aferidor responsável pelas aferições' },
    { header: 'Número', attr: 'aferidor_numero', headerTooltip: 'Número de matrícula do aferidor' },
    {
      header: 'Status',
      headerTooltip: 'Indica se o aferidor está ativo ou inativo no sistema',
      template: (rowData: any) => `
          <span class="status-badge text-white ${rowData.enabled ? 'bg-success' : 'bg-secondary'}">
              ${rowData.enabled ? 'Ativo' : 'Inativo'}
          </span>`
    },
    { header: 'Quantidade Aferições', attr: 'quantidadeAfericoes', headerTooltip: 'Total de DIOs aferidas pelo aferidor no período' },
  ];

  columnsInativos: GenerateTableColumn[] = [
    { header: 'Aferidor', attr: 'aferidor_nome', headerTooltip: 'Nome completo do aferidor responsável pelas aferições' },
    { header: 'Número', attr: 'aferidor_numero', headerTooltip: 'Número de matrícula do aferidor' },
    {
      header: 'Status',
      headerTooltip: 'Indica se o aferidor está ativo ou inativo no sistema',
      template: () => `
          <span class="status-badge text-white bg-secondary">
              Inativo
          </span>`
    },
    { header: 'Quantidade Aferições', attr: 'quantidadeAfericoes', headerTooltip: 'Total de DIOs com a aferição com o status ATRIBUÍDA ao aferidor, ou seja, DIOs que ainda não tiveram a aferição iniciadas.' },
    { 
      tdClass: 'td-w-auto',
      btnProps: { 
        label: 'Distribuir DIOs',
        show: (rowData: any) => rowData.quantidadeAfericoes == 0 ? false : true
      },      
      click: {
        action: (rowData: Aferidores) => this.distribuirDios(rowData.aferidor_id!)
      } 
    },
  ];

  constructor(
    private afericaoService: AfericaoService,
    private aferidorService: AferidorService,
    protected override beneficiariaService: BeneficiariaService,
    protected override snackBar: MatSnackBar,
  ) {
      super(beneficiariaService, snackBar);
  }

  ngOnInit(): void {
    this.afericaoService.findAfericaoAferidores().subscribe({
      next: (res) => {
        this.aferidoresAtivos = res.aferidoresAtivos;
        this.aferidoresInativos = res.aferidoresInativos;
      },
      error: (err) => this.snackBar.open('Erro ao carregar aferidores', 'OK', { duration: 5000 })
    }).add(() => this.loading = false);
  }

  search(pageEvent?: GenerateTablePageEvent) {
  }

  export(type: string = 'csv') {

  }

  distribuirDios(aferidorId: string) {
    console.log('Distribuir DIOs para o aferidor: ', aferidorId);
    this.loading = true;

    this.aferidorService.distribuirAfericoes(aferidorId).subscribe({
      next: (res) => {
        this.snackBar.open('DIOs distribuídas com sucesso!', 'OK', { duration: 5000 });
        this.ngOnInit();
      },
      error: (err) => this.snackBar.open('Erro ao distribuir DIOs', 'OK', { duration: 5000 }),      
    }).add(() => this.loading = false);
  }

}
